export default __webpack_public_path__ + "b35811949030532a41cf0bb518e69bf4.svg";